import { cx } from "@/utils/cx";
import {
	REPORT_SUMMARY_CARD_ICONS,
	REPORT_SUMMARY_CATEGORY_TEXT_COLORS,
} from "../constants";
import { EXPENSE_TYPE_CODE_LABELS, type ExpenseTotalByType } from "../types";
import { formatCurrency } from "../utils";

type VehicleExpenseTotalsByTypeProps = {
	totalsByType: ExpenseTotalByType[];
};
export const VehicleExpenseTotalsByType = ({
	totalsByType,
}: VehicleExpenseTotalsByTypeProps) => {
	if (!totalsByType.length) {
		return null;
	}

	return (
		<div className="mt-4 border-border-secondary border-t pt-3">
			<ul className="space-y-3">
				{totalsByType.map((cat) => {
					const Icon = REPORT_SUMMARY_CARD_ICONS[cat.type];
					const typeLabel = EXPENSE_TYPE_CODE_LABELS[cat.type];
					const color = REPORT_SUMMARY_CATEGORY_TEXT_COLORS[cat.type];

					return (
						<li
							className="flex items-center justify-between text-sm"
							key={cat.type}
						>
							<div className="flex items-center gap-2">
								<Icon className={cx(color, "size-3.5")} />
								<span className="text-tertiary">{typeLabel}</span>
							</div>
							<span className="font-bold text-primary">
								{formatCurrency(cat.total)}
							</span>
						</li>
					);
				})}
			</ul>
		</div>
	);
};
